import { business } from "../config/business";

// Builds a WhatsApp deep link pre-filled with submitted form data.
// There's no WhatsApp Business API/webhook in this app (that requires a paid,
// server-side integration), so "form data going to WhatsApp" is implemented
// the honest, working client-side way: open the user's own WhatsApp with a
// message already composed, ready to send to the business number.
export const buildWhatsAppMessage = (title, fields) => {
  const lines = Object.entries(fields)
    .filter(([, value]) => value)
    .map(([label, value]) => `*${label}:* ${value}`);
  return [`*${title}*`, "", ...lines].join("\n");
};

const buildWhatsAppUrl = (title, fields) => {
  const message = buildWhatsAppMessage(title, fields);
  return `https://api.whatsapp.com/send?phone=${business.whatsapp.number}&text=${encodeURIComponent(message)}`;
};

export const openWhatsAppWithMessage = (title, fields) => {
  window.open(buildWhatsAppUrl(title, fields), "_blank");
};

// Mobile Safari/Chrome only allow window.open() to skip the popup blocker when
// it's called synchronously inside a user gesture (click/submit handler). Any
// `await` before the call (e.g. a Firebase fetch) breaks that chain and the
// tab silently fails to open — the visitor sees a success message but the
// business never gets the WhatsApp message. Fix: open a blank tab immediately,
// synchronously, on the gesture, then point it at the real URL once the
// message is ready.
export const openWhatsAppTab = () => {
  try {
    return window.open("", "_blank");
  } catch {
    return null;
  }
};

// Returns true if the tab was successfully navigated (i.e. wasn't blocked).
export const navigateWhatsAppTab = (tab, title, fields) => {
  const url = buildWhatsAppUrl(title, fields);
  if (tab && !tab.closed) {
    tab.location.href = url;
    return true;
  }
  return false;
};

export const getWhatsAppUrl = (title, fields) => buildWhatsAppUrl(title, fields);
